import React, { FC } from 'react'
import { useTranslations } from 'next-intl'
import {
  CALL_CODE_BUTTON_DEFAULT_TEXT,
  DIVIDER_BUTTON_DEFAULT_TEXT,
  SMS_CODE_BUTTON_DEFAULT_TEXT,
} from '../../constants'
import { Button2 } from '../../../Button2/Button2'
import style from './CallOrSmsButton.module.css'

type SendSmsButtonProps = {
  onCallMouseDownHandler(): void
  onSmsMouseDownHandler(): void
  timeout: number
}

export const CallOrSmsButton: FC<SendSmsButtonProps> = ({ timeout, onCallMouseDownHandler, onSmsMouseDownHandler }) => {
  const t = useTranslations()

  const smsText = t(SMS_CODE_BUTTON_DEFAULT_TEXT)
  const callText = t(CALL_CODE_BUTTON_DEFAULT_TEXT)
  const or = t(DIVIDER_BUTTON_DEFAULT_TEXT)

  return (
    <div>
      {!timeout && (
        <>
          <Button2 isInline onMouseDown={onCallMouseDownHandler}>
            {callText}
          </Button2>
          <span className={style.divider}>{or}</span>
          <Button2 isInline onMouseDown={onSmsMouseDownHandler}>
            {smsText}
          </Button2>
        </>
      )}
    </div>
  )
}

CallOrSmsButton.displayName = 'CallOrSmsButton'
